/**
 * Check if the value is a zero value string like "0px" or "0%"
 */
var isZeroValueString = function isZeroValueString(v) {
  return /^0(?:(?![\t-\r \.\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])[\s\S])+$/.test(v);
};

export { isZeroValueString };